<div class="lg:text-lg font-semibold lg:text-right text-black">Einwilligung gültig für</div>

<div class="flex flex-col mt-4">
  <div class="mb-6">
    <div class="flex justify-between items-center lg:p-2 lg:border-2 lg:border-transparent lg:hover:border-black lg:transition-colors lg:duration-300">
      <div class="order-last lg:order-first"></div>
      <div class="flex flex-col font-light text-lightText lg:text-right order-first lg:order-last">
        <span>Toyota {{ CountryCodeHelper.isCountryAustria() ? 'Austria' : 'Deutschland'}} GmbH</span>
        <span>Toyota Motor Europe NV/SA</span>
      </div>
    </div>
  </div>

  @if (customerConsentRequest.groupDealerList.length > 0) {
    @for (groupDealer of customerConsentRequest.groupDealerList; track groupDealer.dealerNumber; let i = $index) {
      <div class="mb-6">
        <div class="flex justify-between items-center lg:p-2 lg:border-2 lg:border-transparent lg:hover:border-black lg:transition-colors lg:duration-300">
          <div class="flex items-center gap-2 cursor-pointer order-last lg:order-first" (click)="removeDealer(i, groupDealer)">
            <img src="assets/icons/remove.png" class="w-[24px] h-[24px] lg:w-[28px] lg:h-[28px]">
            <span class="underline">Entfernen</span>
          </div>

          <div class="flex flex-col font-light text-lightText lg:text-right order-first lg:order-last">
            @for (fullCompanyName of groupDealer.fullCompanyNameAsList; track fullCompanyName) {
              <span>{{ fullCompanyName }}</span>
            }
          </div>
        </div>
      </div>
    }
  }
</div>
